import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  effect,
  input,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ProductCard } from './product-card.class';
import { Product } from '@core/models/piramide/Product';
import { PromosService } from '@core/services/promos.service';
import { IActionButtonData } from 'src/app/home-page/components/action-button/IActionButtonData.model';
import { ActionButtonComponent } from 'src/app/home-page/components/action-button/action-button.component';
import { BehaviorSubject, map, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from '@environments/environment';
import { BootstrapQueryService } from 'src/app/home-page/services/bootstrap-query.service';
import { MatDialog } from '@angular/material/dialog';
import { ArmaPcService } from '../../../arma-pc/services/arma-pc.service';
import { HighlightedProductsService } from '@core/services/highlighted-products.service';
import { ItemImageComponent } from '../item-image/item-image.component';
import { LiquidationLogoComponent } from '@core/components/liquidation-logo/liquidation-logo.component';
import { IsProductHighlightedPipe } from '@core/pipes/is-product-highlighted.pipe';
import { MaterialModule } from 'src/app/material.module';
import { LiquidationModel } from 'src/app/products/components/liquidation-section/components/liquidation-card/liquidation-card.model';
import { DataLayerService } from '@core/services/data-layer.service';
import { ShoppingCartService } from 'src/app/shopping-cart/services/shoppingCart.service';

@Component({
  selector: 'cgw-product-card',
  standalone: true,
  imports: [
    ActionButtonComponent,
    MaterialModule,
    CommonModule,
    RouterModule,
    ItemImageComponent,
    LiquidationLogoComponent,
    IsProductHighlightedPipe,
  ],
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardComponent implements OnInit, OnDestroy {
  public environment = environment;
  public readonly product = input.required<Product>();
  public assetsImage = environment.apiImageStatic + '/mkt/liquidacion/';
  private _vertical: boolean = false;
  @Input() responsive?: boolean = false;
  @Input()
  set vertical(value: boolean) {
    this._vertical = value;
    this.addCardButton.title = !this._vertical ? 'Sumar al carrito' : null;
  }
  get vertical(): boolean {
    return this._vertical;
  }

  @Input() size: 'small' | 'medium' | 'large' | 'natural' = 'small';
  @Input() typeOnClick: 'armatupc' | 'goToProduct' | null = 'goToProduct';
  @Input() cartButton: boolean = false;
  @Input() info: boolean = false;
  @Input() actionButtons: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public readonly cartCount = computed(() => {
    const productId = this.product()?.id_producto;

    return this.shoppingCartService.getQuantityIdProduct(productId)();
  });
  public readonly cartCount$ = computed(() => {
    const productId = this.product()?.id_producto;
    return this.shoppingCartService.getQuantityIdProduct(productId);
  });
  private shoppingCartSubscription$: Subscription;
  public productCard: ProductCard;
  public addCardButton: IActionButtonData = {
    icon: 'shopping_cart',
    type: 'primary',
    action: (param?) => {
      this.addToCart();
    },
    disabled: false,
    throttleTime: 700,
  };

  constructor(
    private shoppingCartService: ShoppingCartService,
    public bootstrapQueryService: BootstrapQueryService,
    public dialog: MatDialog,
    public armaPcService: ArmaPcService,
    private dataLayerService: DataLayerService,
    public promosService?: PromosService,
    public highlightedProductsService?: HighlightedProductsService,
    private cdr?: ChangeDetectorRef,
  ) {
    effect(() => {
      this.checkButton();
    });
  }

  public ngOnInit(): void {
    this.bootstrapQueryService.getQueries().subscribe((r) => {
      if (!this.vertical) {
        if (r == 'lg' || r == 'md' || r == 'xs') {
          this.addCardButton.title = null;
        } else {
          this.addCardButton.title = 'Sumar al carrito';
        }
      }
    });
    this.productCard = new ProductCard(this.product());
  }
  public addToCart(): void {
    if (!this.addCardButton.disabled) {
      this.shoppingCartService.addProduct(this.product().id_producto);

      this.dataLayerService.addToCart(
        `${this.product().id_producto}--${this.product().nombre}`,
        this.productCard.price,
      );
    }
  }

  private checkButton(): void {
    const quantitySelected = this.shoppingCartService.getQuantityIdProduct(
      this.product().id_producto,
    )();

    if (this?.product) {
      this.addCardButton.disabled =
        !this.product().stock ||
        this.product().stock <= quantitySelected ||
        !this.product().vendible;
    }
    this.cdr.markForCheck();
  }

  public ngOnDestroy(): void {
    this.shoppingCartSubscription$?.unsubscribe();
  }

  public onActionButtonClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  public getLiquidationName(productCardLiquidations: LiquidationModel[]): string {
    return productCardLiquidations?.find((l) => l.status() == 'active')?.name;
  }
}
